import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { brl } from "@/lib/format";
import { Plus, Edit, Trash2, Search } from "lucide-react";
import { toast } from "sonner";
import ProductForm from "./ProductForm";

export default function Products() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState("");
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const [p, c] = await Promise.all([
      api.get("/admin/products"), api.get("/categories"),
    ]);
    setItems(p.data.items); setCats(c.data); setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const del = async (p) => {
    if (!window.confirm(`Excluir "${p.name}"?`)) return;
    await api.delete(`/admin/products/${p.id}`);
    toast.success("Produto excluído");
    load();
  };

  const filtered = items.filter((p) => !q || p.name.toLowerCase().includes(q.toLowerCase()));
  const catName = (id) => cats.find((c) => c.id === id)?.name || "—";

  return (
    <div className="space-y-5" data-testid="admin-products">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-serif text-3xl text-[#4A3B40]">Produtos</h1>
        <button onClick={()=>{setEditing(null); setShowForm(true);}} className="btn-lara" data-testid="admin-product-create-btn">
          <Plus className="w-4 h-4" /> Novo produto
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-4">
        <div className="flex items-center gap-2 bg-[#FFF9FA] rounded-full border border-[#F9E1E8] px-4 py-2 mb-4 max-w-md">
          <Search className="w-4 h-4 text-[#8C7A80]" />
          <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Buscar..." className="bg-transparent outline-none text-sm flex-1" data-testid="admin-products-search" />
        </div>

        {loading ? <p className="text-[#8C7A80] p-6">Carregando...</p> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-[#8C7A80] uppercase border-b border-[#F9E1E8]">
                  <th className="pb-2">Produto</th><th className="pb-2">Categoria</th><th className="pb-2">Preço</th><th className="pb-2">Estoque</th><th className="pb-2">Ativo</th><th className="pb-2 text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((p) => (
                  <tr key={p.id} className="border-b border-[#F9E1E8] last:border-0" data-testid={`admin-product-row-${p.slug}`}>
                    <td className="py-3">
                      <div className="flex items-center gap-3">
                        <img src={(p.images||[])[0] || ""} className="w-10 h-10 rounded-lg object-cover bg-[#F9E1E8]" alt="" />
                        <div>
                          <p className="text-[#4A3B40] font-medium line-clamp-1 max-w-xs">{p.name}</p>
                          <p className="text-xs text-[#8C7A80]">{p.sku}</p>
                        </div>
                      </div>
                    </td>
                    <td className="text-[#8C7A80]">{catName(p.category_id)}</td>
                    <td className="font-semibold text-[#C9708B]">{brl(p.promo_price || p.price)}</td>
                    <td className={p.stock<=5 ? "text-[#E57373] font-semibold" : ""}>{p.stock}</td>
                    <td>{p.active ? <span className="text-[#7DBE9E]">●</span> : <span className="text-[#8C7A80]">○</span>}</td>
                    <td className="text-right">
                      <button onClick={()=>{setEditing(p); setShowForm(true);}} className="text-[#C9708B] p-1" data-testid={`admin-product-edit-${p.slug}`}><Edit className="w-4 h-4" /></button>
                      <button onClick={()=>del(p)} className="text-[#E57373] p-1 ml-1" data-testid={`admin-product-delete-${p.slug}`}><Trash2 className="w-4 h-4" /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showForm && (
        <ProductForm
          product={editing}
          categories={cats}
          onClose={() => setShowForm(false)}
          onSaved={() => { setShowForm(false); load(); }}
        />
      )}
    </div>
  );
}
